"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPage = exports.renderLayout = void 0;
const lit_1 = require("lit");
const unsafe_html_js_1 = require("lit/directives/unsafe-html.js");
require("@/components/common");
require("@/components/layouts/app-sidebar");
require("@/components/layouts/fixed-bottom");
require("@/components/layouts/fixed-top");
require("@/stylesheets/shared.css");
const renderLayout = (content, options = {}) => {
    const navbar = options.navbar ?? true;
    const body = typeof content === 'string' ? (0, unsafe_html_js_1.unsafeHTML)(content) : content;
    (0, lit_1.render)((0, lit_1.html) `
      ${navbar
        ? (0, lit_1.html) `
            <mm-navbar></mm-navbar>
            <mm-sidebar id="site-sidebar" ?open=${!options.closeSidebar}></mm-sidebar>
          `
        : lit_1.nothing}
      ${body}
      ${options.footer
        ? (0, lit_1.html) `
            <mm-footer></mm-footer>
          `
        : lit_1.nothing}
    `, document.body);
};
exports.renderLayout = renderLayout;
/**
 * 페이지 진입점. DOM이 준비되면 셸을 렌더하고, 이어서 initialize로 페이지별 배선을 실행한다.
 */
const renderPage = (content, options = {}) => {
    document.addEventListener('DOMContentLoaded', () => {
        (0, exports.renderLayout)(content, options);
        options.initialize?.();
    });
};
exports.renderPage = renderPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS1sYXlvdXRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYmFzZS1sYXlvdXRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUFnRTtBQUNoRSxrRUFBMEQ7QUFFMUQsK0JBQTRCO0FBQzVCLDRDQUF5QztBQUN6Qyw2Q0FBMEM7QUFDMUMsMENBQXVDO0FBRXZDLG9DQUFpQztBQVkxQixNQUFNLFlBQVksR0FBRyxDQUFDLE9BQWdDLEVBQUUsVUFBeUIsRUFBRSxFQUFFLEVBQUU7SUFDNUYsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sSUFBSSxJQUFJLENBQUE7SUFDckMsTUFBTSxJQUFJLEdBQUcsT0FBTyxPQUFPLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFBLDJCQUFVLEVBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQTtJQUV4RSxJQUFBLFlBQU0sRUFDSixJQUFBLFVBQUksRUFBQTtRQUNBLE1BQU07UUFDTixDQUFDLENBQUMsSUFBQSxVQUFJLEVBQUE7O2tEQUVvQyxDQUFDLE9BQU8sQ0FBQyxZQUFZO1dBQzVEO1FBQ0gsQ0FBQyxDQUFDLGFBQU87UUFDVCxJQUFJO1FBQ0osT0FBTyxDQUFDLE1BQU07UUFDZCxDQUFDLENBQUMsSUFBQSxVQUFJLEVBQUE7O1dBRUg7UUFDSCxDQUFDLENBQUMsYUFBTztLQUNaLEVBQ0QsUUFBUSxDQUFDLElBQUksQ0FDZCxDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBckJZLFFBQUEsWUFBWSxnQkFxQnhCO0FBRUQ7O0dBRUc7QUFDSSxNQUFNLFVBQVUsR0FBRyxDQUN4QixPQUFnQyxFQUNoQyxVQUF1RCxFQUFFLEVBQ3pELEVBQUU7SUFDRixRQUFRLENBQUMsZ0JBQWdCLENBQUMsa0JBQWtCLEVBQUUsR0FBRyxFQUFFO1FBQ2pELElBQUEsb0JBQVksRUFBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUE7UUFDOUIsT0FBTyxDQUFDLFVBQVUsRUFBRSxFQUFFLENBQUE7SUFDeEIsQ0FBQyxDQUFDLENBQUE7QUFDSixDQUFDLENBQUE7QUFSWSxRQUFBLFVBQVUsY0FRdEIifQ==